import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const t = localStorage.getItem("lo_admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const IMG_URL = (id) => `${API}/images/${id}`;
